import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { AuthService } from '../../auth/auth.service';
import { switchMap, catchError } from 'rxjs/operators';
import { isExternalApi } from './interceptor-utils';

@Injectable()
export class HttpTokenInterceptor implements HttpInterceptor {

    constructor(private authService: AuthService) { }

    private exemptedUrls: string[] = [
        '/twoFactorAuth',
        '/login',
        '/login/groups',
        '/forgot-password',
        '/forgot-password/email',
        '/forgot-password/confirm',
        '/forgot-password/confirm/validate',
        '/refresh-token',
        '/api/logout',
        '/members/verify',
        '/members/accept',
        '/saml/confirm',
        '/notifications/unsubscribe',
        '/notifications/check-status'
    ];

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (isExternalApi(req.url)) {
            return next.handle(req);
        }

        if (this.exemptedUrls.some(url => req.url.includes(url))) {
            return next.handle(req);
        }

        if (this.authService.isAuthenticated()) {
            return next.handle(this.addToken(req));
        }

        // Token is expired — delegate to AuthService which serialises concurrent callers
        return this.handleExpiredToken(req, next);
    }

    private addToken(request: HttpRequest<any>): HttpRequest<any> {
        return request.clone({
            setHeaders: {
                Authorization: `${this.authService.getToken()}`
            }
        });
    }

    private handleExpiredToken(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // authService.getRefreshToken() is idempotent: if a refresh is already in flight,
        // all concurrent callers receive the same shared observable (shareReplay(1)).
        // No local isRefreshing guard is needed here.
        return this.authService.getRefreshToken().pipe(
            switchMap(() => next.handle(this.addToken(request))),
            catchError(error => throwError(error))
        );
    }
}
